import { render, staticRenderFns } from "./OmniSidebarItem.vue?vue&type=template&id=86d6330e&"
import script from "./OmniSidebarItem.vue?vue&type=script&lang=js&"
export * from "./OmniSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./OmniSidebarItem.vue?vue&type=style&index=0&id=86d6330e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports